import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentIMISPublicationHit } from '../../../../SearchAllContent/types';
import ButtonWrapper from '../../../../ButtonWrapper';
import Card from '../../../../Card';

import './style.scss';

export interface MetaSearchIMISPublicationHitProps {
  hit: SearchAllContentIMISPublicationHit;
}

const MetaSearchIMISPublicationHit: React.FC<MetaSearchIMISPublicationHitProps> = (props) => {
  const { hit } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'custom_entities.nioz_publication_imis' });

  const brefId = hit.imis_publication_bref_id[0];
  const title = hit.imis_publication_title[0];
  const year = hit.imis_publication_year?.[0];
  const journal = hit.imis_publication_journal[0];
  const authors = hit.imis_publication_authors[0];

  const fullReference = `https://imis.nioz.nl/imis.php?module=ref&refid=${brefId}`;

  let citation = `<span class="IMISPublicationCard__authors">${authors}</span>`;

  if (year) {
    citation = citation.concat(`&nbsp;(${year})`);
  }

  citation = citation.concat(`&nbsp;${title}`);

  if (journal) {
    citation = citation.concat(journal);
  }

  const classes = c('IMISPublicationCard', {
    [`IMISPublicationCard__year__${year ?? ''}`]: year !== undefined,
  });

  return (
    <Card className={classes} withLink={false}>
      <Card.Content>
        <h2 className="IMISPublicationCard__year asH1">{year}</h2>
        <Card.Subtitle
          subtitle={(
            <>
              <WysiwygField className="IMISPublicationCard__citation" html={citation} />
              <ButtonWrapper
                href={fullReference}
                type="textual"
                className="IMISPublicationCard__fullReference"
              >
                {t('card_link_title')}
              </ButtonWrapper>
            </>
          )}
        />
      </Card.Content>
    </Card>
  );
};

export default MetaSearchIMISPublicationHit;
